import { Plan } from '@/types/common';
import { ChangeEvent } from 'react';
import {
  MobilePlanUnlocksList,
  PlanUnlocksList,
} from '../../common/PlanDetails';

export const PlanRadioOption = ({
  plan,
  memberIndex,
  selectedPlan,
  currentPlan,
  price,
  onChange,
  detailsExpanded,
  onToggleDetailsExpanded,
  formatAnnualPriceDigits,
}: {
  plan: Plan;
  memberIndex: number | string;
  selectedPlan?: Plan;
  currentPlan?: Plan;
  price: number;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  detailsExpanded?: boolean;
  onToggleDetailsExpanded?: (next: boolean) => void;
  formatAnnualPriceDigits?: (amount: number) => string;
}) => {
  const annualPriceDigits =
    formatAnnualPriceDigits?.(price) ??
    price.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

  return (
    <>
      <label
        htmlFor={`member_${memberIndex}_${plan}_option`}
        className='border-gray has-checked:bg-sh-yellow my-4 flex cursor-pointer items-center rounded-full border p-4'
      >
        <input
          id={`member_${memberIndex}_${plan}_option`}
          className={`relative size-6 flex-shrink-0 cursor-pointer appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full not-checked:before:hidden checked:border-gray-300 checked:bg-gray-300 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-300 disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden`}
          name={`plan_member_${memberIndex}`}
          type='radio'
          value={plan}
          checked={plan === selectedPlan}
          onChange={onChange}
        />
        <span className='sh-body ml-3 grow-1 text-[18px] font-light sm:text-[18px]'>
          Sollis {plan} Plan {currentPlan === plan && '(Current)'}
        </span>
        <span className='sh-body text-[18px] font-light sm:text-[18px]'>
          ${annualPriceDigits}/yr
        </span>
      </label>
      {plan === selectedPlan && (
        <div>
          <div className='block lg:hidden'>
            <MobilePlanUnlocksList
              plan={plan}
              expanded={detailsExpanded}
              onToggle={onToggleDetailsExpanded}
            />
          </div>
          <div className='hidden lg:block'>
            <PlanUnlocksList plan={plan} />
          </div>
        </div>
      )}
    </>
  );
};
